// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2J5D1","rightAdornment":"Header_rightAdornment__1EiTO"};